import { z } from "zod";
import { nonEmptyString } from "../zod/nonEmptyString.js";

export const ckEditorBlockSchema = z.object({
	html: nonEmptyString,
});
